import {cn} from 'platform/shared-tw';

import {createKeyDownHandler, partStroke, type DiagramVariant} from '../shared/partVariants';

interface PipesProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function Pipes(props: PipesProps) {
  const pathClass = cn(
    partStroke({variant: props.variant}),
    props.onClick && '[pointer-events:stroke]'
  );

  return (
    <svg
      width="285"
      height="400"
      viewBox="0 0 285 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute focus:outline-none focus-visible:outline-none [pointer-events:none] ${props.onClick ? 'cursor-pointer group' : ''}`}
      style={{top: 52, left: 31}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
      aria-label={props.onClick ? 'Pipes' : undefined}
    >
      <path
        d="M170 2H199C199 2 204 2 204 7.99987C204 7.99987 204.002 49.7432 204.002 64.9986"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path d="M150 2H126" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path
        d="M204 100.998L204 120.998"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M214 100.998L214 120.998"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M230 81.9982L284 81.9982"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M104 38.9992L104 81.9982C103.998 91.998 113.998 91.998 113.998 91.998H173.998"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M81 82.0038L174 81.9982"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M81 71.9988H150C161 71.9988 161 60.9988 161 60.9988V54.9988"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path d="M46 198.996H84" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path
        d="M114 38.9992L114 127.997"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M22 198.996H10C2 198.996 2 189.996 2 189.996C2 189.996 2 121.997 2 110.997C2 99.9978 43 22.9994 53 22.9994L65 22.9995"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path d="M82 344.992V371.992" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path d="M149 358.992V386.992" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path d="M230 397.991L157 398" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path
        d="M230 387.991H194C179 387.991 179 375.492 179 370.414C179 370.414 179.001 339.443 179.001 327.218C179.001 314.993 187.894 314.993 187.894 314.993H203"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M60 298.993V219.995C60 208.995 69 208.995 69 208.995L84 208.995"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path d="M227 315H285" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path d="M242 344.992H223" stroke="currentColor" className={pathClass} strokeWidth="3" />
      <path
        d="M207 344.992H193C191 344.992 188 345.992 188 349.992V371.992C188 373.071 188 377.992 194 377.992H230"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
      <path
        d="M174 37.9992H201C201 37.9992 214 37.9992 214 49.9992V64.9992"
        stroke="currentColor"
        className={pathClass}
        strokeWidth="3"
      />
    </svg>
  );
}
